import { Component } from '@angular/core';

@Component({
  selector: 'app-user-profile-clubs-and-teams-tab',
  templateUrl: './user-profile-clubs-and-teams-tab.component.html',
  styleUrls: ['./user-profile-clubs-and-teams-tab.component.scss']
})
export class UserProfileClubsAndTeamsTabComponent {

}
